export const SET_CAMPS_PROPERTY = 'SET_CAMPS_PROPERTY';
export const CAMPS_GET_MASTER_DATA = 'CAMPS_GET_MASTER_DATA';
export const CAMPS_UPDATE_MASTER_DATA = 'CAMPS_UPDATE_MASTER_DATA';
export const CAMPS_ERROR = 'CAMPS_ERROR';
export const CAMPS_CARS_RESET_FILTERS = 'CAMPS_CARS_RESET_FILTERS';
export const CAMPS_TASKS_LIST_RESET_FILTERS = 'CAMPS_TASKS_LIST_RESET_FILTERS';

export const CAMPS_GET_CARS = 'CAMPS_GET_CARS';
export const CAMPS_GET_CAR_DETAIL = 'CAMPS_GET_CAR_DETAIL';
export const CAMPS_UPDATE_KM = 'CAMPS_UPDATE_KM';
export const CAMPS_GET_CAR_ACCESSORIES = 'CAMPS_GET_CAR_ACCESSORIES';
export const CAMPS_UPDATE_TASK_STATE = 'CAMPS_UPDATE_TASK_STATE';
export const CAMPS_GET_TASKS = 'CAMPS_GET_TASKS';
export const CAMPS_TASKS_RESET_FILTERS = 'CAMPS_TASKS_RESET_FILTERS';
export const CAMPS_GET_TASK_DETAIL = 'CAMPS_GET_TASK_DETAIL';
export const CAMPS_GET_PAPS = 'CAMPS_GET_PAPS';
export const CAMPS_PAPS_LIST_RESET_FILTERS = 'CAMPS_PAPS_LIST_RESET_FILTERS';
export const CAMPS_PAPS_ASSOCIATED_TASKS_RESET_FILTERS =
  'CAMPS_PAPS_ASSOCIATED_TASKS_RESET_FILTERS';
export const CAMPS_GET_PAP_DETAIL = 'CAMPS_GET_PAP_DETAIL';
export const CAMPS_UPDATE_EXT_ACCESSORIES = 'CAMPS_UPDATE_EXT_ACCESSORIES';
export const CAMPS_UPDATE_INT_ACCESSORIES = 'CAMPS_UPDATE_INT_ACCESSORIES';
export const CAMPS_UPDATE_INT_DAMAGES = 'CAMPS_UPDATE_INT_DAMAGES';
export const CAMPS_UPDATE_EXT_DAMAGES = 'CAMPS_UPDATE_EXT_DAMAGES';
export const CAMPS_SAVE_DETAIL_PAP = 'CAMPS_SAVE_DETAIL_PAP';
export const CAMPS_RESET_EMPLOYEES_TRANSPORT_LIST_FILTERS =
  'CAMPS_RESET_EMPLOYEES_TRANSPORT_LIST_FILTERS';
export const CAMPS_RESET_MANAGERS_TRANSPORT_LIST_FILTERS =
  'CAMPS_RESET_MANAGERS_TRANSPORT_LIST_FILTERS';
export const CAMPS_TRANSPORT_EMPLOYEES_GET_LIST = 'CAMPS_TRANSPORT_EMPLOYEES_GET_LIST';
export const CAMPS_TRANSPORT_MANAGERS_GET_LIST = 'CAMPS_TRANSPORT_MANAGERS_GET_LIST';
export const CAMPS_GET_DISCREPANCIES = 'CAMPS_GET_DISCREPANCIES';
export const CAMPS_RESET_TIRES = 'CAMPS_RESET_TIRES';
